/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Save_SuccessInputs */

const en_admin_settings_save_success = /** @type {(inputs: Admin_Settings_Save_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings saved`)
};

/**
* | output |
* | --- |
* | "Settings saved" |
*
* @param {Admin_Settings_Save_SuccessInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_save_success = /** @type {((inputs?: Admin_Settings_Save_SuccessInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Save_SuccessInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_save_success(inputs)
});
export { admin_settings_save_success as "admin.settings.save_success" }